export const repo = async (args?: string[]): Promise<string> => {
  setTimeout(function () {
    window.open('https://github.com/andythsu', '_blank');
  }, 1000);

  return 'Opening repository...';
};
